import { Component, OnInit, ViewChild, } from '@angular/core';
import { environment } from 'environments/environment';
import { SfhSecurityService } from '@sasser/sfh-shared-security';
import { SignalRService } from '../../components/common/notification/signal-r.service';
import { GlobalSearchResult } from 'app/components/common/search/global-search-result.model';
import { Observable, Subject } from 'rxjs';
import { SharedModule } from 'app/shared/shared.module';
import { GlobalSearchComponent } from 'app/components/common/search/global-search.component';
declare var jQuery: any;

@Component({
	standalone: true,
	selector: 'starter',
	templateUrl: './starter.template.html',
	imports: [SharedModule, GlobalSearchComponent], 
})
export class StarterViewComponent implements OnInit {

	public nav: any;
	public env: any;
	public results$: Observable<GlobalSearchResult[]>;
	public results$Loading: boolean;
	public searchTerm$ = new Subject<string>();
	public displayInput = true;
	public show360Search = 'show';
	@ViewChild('globalSearch') globalSearch;
	public constructor(
		public sfhAuth: SfhSecurityService,
		private hubConnectionService: SignalRService,
	) { }

	public ngOnInit(): any {
		this.env = environment.name;
		if (this.sfhAuth.isAuthenticated()) {
			this.setFocus();
		}
		this.sfhAuth.events.subscribe(result => {
			if (result === 'user_loaded') {
				this.hubConnectionService.connect();
				if (this.sfhAuth.isAuthenticated()) {
					this.setFocus();
					setTimeout(() => {
						jQuery('li a', '#side-menu').on('click', function () {
							const anchor = jQuery(this);
							const subMenu = anchor.next('ul');
							if (subMenu && subMenu.hasClass('mm-collapse')) {
								if (subMenu.hasClass('mm-show')) {
									subMenu.metisMenu().data('metisMenu').hide(subMenu);
									anchor.attr('aria-expanded', false);
								} else {
									subMenu.metisMenu().data('metisMenu').show(subMenu);
									anchor.attr('aria-expanded', true);
								}
							}
						});
					}, 200);					
				}
			}
		});	
	}

	login() {
		this.sfhAuth.login();
	}

	public setFocus() {
		setTimeout(() => {
			this.globalSearch.setFocus();
		},
		100);
	}
}